/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortalDocument } from './PortalDocument';
import {
    PortalDocumentFromJSON,
    PortalDocumentFromJSONTyped,
    PortalDocumentToJSON,
    PortalDocumentToJSONTyped,
} from './PortalDocument';

/**
 * 
 * @export
 * @interface PortalDocumentList
 */
export interface PortalDocumentList {
    /**
     * 
     */
    documents: Array<PortalDocument>;
}

/**
 * Check if a given object implements the PortalDocumentList interface.
 */
export function instanceOfPortalDocumentList(value: object): value is PortalDocumentList {
    if (!('documents' in value) || value['documents'] === undefined) return false;
    return true;
}

export function PortalDocumentListFromJSON(json: any): PortalDocumentList {
    return PortalDocumentListFromJSONTyped(json, false);
}

export function PortalDocumentListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalDocumentList {
    if (json == null) {
        return json;
    }
    return {
        
        'documents': ((json['documents'] as Array<any>).map(PortalDocumentFromJSON)),
    };
}

export function PortalDocumentListToJSON(json: any): PortalDocumentList {
    return PortalDocumentListToJSONTyped(json, false);
}

export function PortalDocumentListToJSONTyped(value?: PortalDocumentList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documents': ((value['documents'] as Array<any>).map(PortalDocumentToJSON)),
    };
}

